
define(
	'Ames.OperationGuidesPage.OperationGuidesPage'
,   [
		'Ames.OperationGuidesPage.OperationGuidesPage.View'
	]
,   function (
		OperationGuidesPageView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var pageTypeComponent = container.getComponent("PageType");
			var pageType = {
				name: 'op_guides',
				view: OperationGuidesPageView,
				routes: ['operation-guides'],
				options: {},
				defaultTemplate: {
					name: 'op_guides.tpl',
					displayName: 'Op Guides'
				}
			}

			pageTypeComponent.registerPageType(pageType);

		}
	};
});
